<script setup lang="ts"></script>

<template>
  <header class="sticky top-0">
    <div class="bg-optilynx-purple"></div>
  </header>
</template>
